module.exports = "<ssf-section title=\"{{ i18n + 'ENABLED-APPS' | translate }}\">\n    <ng-container section-buttons>\n        <ssf-consent></ssf-consent>\n    </ng-container>\n    <ssf-enabled-application-list></ssf-enabled-application-list>\n</ssf-section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/applications/components/manage-applications/manage-applications.component.html
// module id = 826
// module chunks = 3